module.exports = "<ul class=\"list-group\">\n\n  <li class=\"list-group-item justify-content-between\">\n    Loading ...\n    <i class=\"fa fa-spinner fa-spin\" aria-hidden=\"true\"></i>\n\n  </li>\n</ul>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/fulfillment.release/src/app/shared/loader/loader.component.html
// module id = ../../../../../src/app/shared/loader/loader.component.html
// module chunks = 0